// @flow
import {fromJS} from 'immutable';
import {upperFirst} from 'lib/stringUtils';
import {getVersionAgnosticResourceType} from 'resources/mandark.resource';
import getQuestionDifficultiesFromQuestionSets from 'lib/getQuestionDifficultiesFromQuestionSets';
import getQuestionDifficultyTotalsFromList from 'lib/getQuestionDifficultyTotalsFromList';
import {TemplateModelV1} from 'resources/GeneratedModels/Template/TemplateModel.v1';
import {AssignmentModelV3} from 'resources/augmented/Assignment/AssignmentModel.v3';
import type {QuestionSetModelV1} from 'resources/GeneratedModels/QuestionSet/QuestionSetModel.v1';

export default function createAssignmentMetadataFromResourceMetadata(
  resource: TemplateModelV1 | AssignmentModelV3,
  folderQuestionSets: QuestionSetModelV1
): Map<*, *> {
  const jsonApiType = resource.getJsonApiType();
  const vart = getVersionAgnosticResourceType(jsonApiType);
  const resourceType = upperFirst(vart);
  const questionSets =
    folderQuestionSets ||
    resource.getQuestionSets().sortBy((questionSet) => {
      return questionSet[`get${resourceType}Position`](resource.getId());
    });
  const questionDifficulties = getQuestionDifficultiesFromQuestionSets(questionSets);

  const questionDifficultyTotals = getQuestionDifficultyTotalsFromList(questionDifficulties);

  const assignmentData = fromJS({
    breadcrumbs: [
      {
        name: resource.getName(),
        url: null
      }
    ],
    breadcrumbLabel: resourceType === 'Template' ? 'Folder' : resourceType,
    questionSetList: questionSets,
    questionDifficultyTotals
  });

  return assignmentData;
}
